import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Page } from '../models/page-wrapper.model';
import { ChatSession } from '../models/chat-session.model';
import { environment } from '../../environments/environment';

export interface ArchivedSessionSearchParams {
  lastActiveFrom?: string;
  lastActiveTo?: string;
  userIds?: number[];
  searchText?: string;
  searchType?: 'LEXICAL' | 'SEMANTIC';
  resourceType?: string;
  businessObjectId?: number;
  page?: number;
  size?: number;
  sort?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ArchiveService {
  private apiUrl = `${environment.restApiUrl}archive/sessions`;

  constructor(private http: HttpClient) { }

  searchArchivedSessions(params: ArchivedSessionSearchParams): Observable<Page<ChatSession>> {
    // Create HttpParams, ensuring array values are handled correctly.
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        httpParams = httpParams.append(key, String(value));
      }
    });
    return this.http.get<Page<ChatSession>>(this.apiUrl, { params: httpParams });
  }
}

